import React from 'react';
import { Route, Switch, Redirect, withRouter, useLocation } from 'react-router-dom';
import SignIn from './signin';
import SignUp from './signup';
import OTP from './otp';
import Forgot from './forgot';
import SetPassword from './setPassword'
import { SignInIllustration, SignUpIllustration } from './authIllustrations';
import '../../assets/styles/auth.css';

const AuthLogo = ({ className = '' }) => (
    <div className={`ib-auth-logo ${className}`}>
        {/* Same cube mark as assets/images/logo.png, as SVG so it sits cleanly on the tinted hero. */}
        <svg viewBox="0 0 48 48" aria-hidden="true">
            <path d="M24 3 L44 14 L24 25 L4 14 Z M24 10.5 L17 14 L24 17.5 L31 14 Z" fill="#1f6feb" fillRule="evenodd" />
            <path d="M4 18 L20 27 V45 L4 36 Z" fill="#1f6feb" />
            <path d="M44 18 L28 27 V45 L44 36 Z" fill="#1f6feb" />
        </svg>
        <span>InsureBox</span>
    </div>
);

// Left-hand hero copy per route — Sign Up gets its own; every other auth
// screen (sign in, OTP, forgot / set password) shares the Sign In hero.
const heroes = {
    signup: {
        title: <>Get Started<br />with <span>InsureBox</span></>,
        text: 'Create your account and start managing your insurance business with ease.',
        Illustration: SignUpIllustration,
    },
    signin: {
        title: <>Simplify<br />Insurance<br /><span>Management</span></>,
        text: 'Powerful tools to manage policies, users, plans and more — all in one place.',
        Illustration: SignInIllustration,
    },
};

const Login = props => {
    const { pathname } = useLocation();
    const hero = pathname.startsWith('/signup') ? heroes.signup : heroes.signin;

    return (
        <div className="kt-login ib-auth" id="kt_login">
            <div className="ib-auth-shell">
                <aside className="ib-auth-hero">
                    <AuthLogo />
                    <h1 className="ib-auth-hero__title">{hero.title}</h1>
                    <p className="ib-auth-hero__text">{hero.text}</p>
                    <hero.Illustration />
                </aside>

                <main className="ib-auth-card kt-login__container">
                    <AuthLogo className="ib-auth-logo--card" />
                    <Switch>
                        <Route path="/signin" exact> <SignIn onLogin={props.onLogin} /> </Route>
                        <Route path="/signup" exact> <SignUp onLogin={props.onLogin} /> </Route>
                        <Route path="/verify/:action" exact> <OTP onLogin={props.onLogin} /> </Route>
                        <Route path="/forgot-password" exact> <Forgot /> </Route>
                        <Route path="/set-password/:uid" > <SetPassword /> </Route>
                        <Redirect to="/signin" />
                    </Switch>
                </main>
            </div>
        </div>
    )
}

export default withRouter(Login);
